import * as types from './action-types';

export const setTheme = theme => (
  {type: types.SET_THEME, theme}
);
